import React from "react";
import { useDispatch } from "react-redux";
import { toggleModal } from "../../../../actions";
import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
} from "mdbreact";
import { useState } from "react";
import { cleanHtmlString, formatHtml } from "./EmailHtmlHelper";
import { useEffect } from "react";

function NotificationTemplateViewModal({
  showModal,
  onClose,
  templateValue,
  templateName,
}) {
  const [html, setHtml] = useState(templateValue);
  const dispatch = useDispatch();
  const handleClose = () => {
    onClose();
    dispatch(toggleModal({ isOpen: false }));
  };
  useEffect(() => {
    if (templateValue) {
      const cleaned = cleanHtmlString(templateValue);
      const formatted = formatHtml(cleaned);
      setHtml(formatted);
    }
  }, [templateValue]);
  return (
    <>
      <div className="child-popup">
        <MDBModal isOpen={showModal} size="lg" toggle={() => handleClose()}>
          <MDBModalHeader>Viewing {templateName || ""} Template</MDBModalHeader>
          <MDBModalBody>
            <div className="modal-body email-preview-body">
              <iframe
                title="email-preview"
                className="email-preview-iframe"
                srcDoc={html}
              />
            </div>
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="secondary" onClick={() => handleClose()}>
              Close
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </div>
    </>
  );
}

export default NotificationTemplateViewModal;
